import React from "react";
import styles from "./pageNotFound.module.css";
import Headerfile from "../common/Headerfile";
import Footerfile from "../common/Footerfile";
import { useNavigate } from "react-router-dom";

const NotFound: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className={styles.container}>
      <Headerfile />
      <div className={styles.innerContainer}>
        <p> The page you're looking for is not found.</p>
        <span className={styles.gotohome} onClick={() => navigate("/home")}>
          Go to Home
        </span>
      </div>
      <Footerfile />
    </div>
  );
};

export default NotFound;
